import { useMemo } from "react";

import { RVSideNavLayout, type PageSubNavItem } from "@regal-voice/ui";
import { usePageAvailability } from "App/routes/Hooks/usePageAvilability/usePageAvailability";
import { TOP_LEVEL_PAGES_TITLE_MAP } from "App/routes/pageNames";
import { AppPagePaths } from "App/routes/paths";
import { AUDIENCE_SUB_NAV_TITLES } from "Pages/audience/audienceMetadata";
import { audiencePathResources } from "Pages/audience/Pages/audiencePaths";
import { CollapsiblePanel } from "Utils/CollapsiblePanels";
import { useKnownPanels } from "Utils/CollapsiblePanels/knownPanels";

import { SegmentsPaths } from "../../Pages/SegmentsPage/segmentPaths";

export function AudienceSubNav(): JSX.Element {
    const { audiencePages } = usePageAvailability();
    const { showContacts, showSegments } = audiencePages;

    const items: PageSubNavItem[] = useMemo(() => {
        const navItems: PageSubNavItem[] = [];

        if (showContacts) {
            navItems.push({
                key: audiencePathResources.contacts,
                title: AUDIENCE_SUB_NAV_TITLES[audiencePathResources.contacts],
                href: `/${audiencePathResources.contacts}`,
            });
        }

        if (showSegments) {
            navItems.push({
                key: audiencePathResources.segments,
                title: AUDIENCE_SUB_NAV_TITLES[audiencePathResources.segments],
                href: `/${audiencePathResources.segments}`,
                tabs: [
                    `/${audiencePathResources.segments}/${SegmentsPaths.new}`,
                    `/${audiencePathResources.segments}/${SegmentsPaths.edit}`,
                ],
            });
        }

        return navItems;
    }, [showContacts, showSegments]);

    const { audience } = useKnownPanels();

    return (
        <CollapsiblePanel panelName={audience.name} expandedWidth={audience.width}>
            <RVSideNavLayout
                sidenavTitle={TOP_LEVEL_PAGES_TITLE_MAP[AppPagePaths.audience]}
                items={items}
                basePath={AppPagePaths.audience}
                hasSubPages
            />
        </CollapsiblePanel>
    );
}
